/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { Root } from "../models/index";
import { RootFromJSON, RootToJSON } from "../models/index";

/**
 *
 */
export class DefaultApi extends runtime.BaseAPI {
  /**
   */
  async rootRetrieveRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Root>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/api/`;

    const response = await this.request(
      {
        path: urlPath,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => RootFromJSON(jsonValue));
  }

  /**
   */
  async rootRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Root> {
    const response = await this.rootRetrieveRaw(initOverrides);
    return await response.value();
  }
}
